import { useEffect } from "react";
import { Row, Col, Form } from "react-bootstrap";
import st from "../../style.module.scss";

const AddLabel = ({ index,
    register,
    handleSubmit,
    watch,
    setError,
    clearErrors,
    errors }) => {

    const min = watch(`noOfYears.${index}.min`);
    const max = watch(`noOfYears.${index}.max`);

    useEffect(() => {
        if (min && max && +min >= +max) {
            setError(`noOfYears.${index}.min`, {
                type: "validate",
                message: "Min must be less than Max",
            });
            setError(`noOfYears.${index}.max`, {
                type: "validate",
                message: "Max must be greater than Min",
            });
        } else {
            if (min && max && +min < +max) {
                clearErrors(`noOfYears.${index}.min`);
                clearErrors(`noOfYears.${index}.max`);
            }
        }
    }, [min, max, clearErrors, setError, index]);

    return (
            <Row>
                <Col lg={12} md={12} className="d-flex justify-content-between">
                    <Form.Group className={`${st.formField} ${st.new_formFields}`}>
                        <Form.Label htmlFor={`noOfYears.${index}.min`}>Min</Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="Min(ex:1)"
                            {...register(`noOfYears.${index}.min`, {
                                required: "min is required",
                            })}
                            isInvalid={!!errors?.noOfYears?.[index]?.min}
                        />
                        <Form.Control.Feedback
                            type="invalid"
                            className={`${errors.noOfYears?.[index]?.min?.message?.length
                                ? "d-block"
                                : "d-none"
                                }`}
                        >
                            {errors.noOfYears?.[index]?.min?.message}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className={`${st.formField} ${st.new_formFields}`}>
                        <Form.Label htmlFor={`noOfYears.${index}.max`}>Max</Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="Max(ex:5)"
                            {...register(`noOfYears.${index}.max`, {
                                required: "max is required",
                            })}
                            isInvalid={!!errors?.noOfYears?.[index]?.max}
                        />
                        <Form.Control.Feedback
                            type="invalid"
                            className={`${errors.noOfYears?.[index]?.max?.message?.length
                                ? "d-block"
                                : "d-none"
                                }`}
                        >
                            {errors.noOfYears?.[index]?.max?.message}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className={`${st.formField} ${st.new_formFields}`}>
                        <Form.Label htmlFor={`noOfYears.${index}.label`}>Label</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="1-5 years"
                            {...register(`noOfYears.${index}.label`, {
                                required: "label is required",
                            })}
                            isInvalid={!!errors?.noOfYears?.[index]?.label}
                        />
                        <Form.Control.Feedback
                            type="invalid"
                            className={`${errors.noOfYears?.[index]?.label?.message?.length
                                ? "d-block"
                                : "d-none"
                                }`}
                        >
                            {errors.noOfYears?.[index]?.label?.message}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>
    );
};
export default AddLabel;